import * as R from 'ramda'

export function createFilterByCantonFunction(selectedCantons) {
    return function (station) {

        //if selectedCantons is null or not defined or contains no elements, return true
        if (selectedCantons === null || selectedCantons === undefined || selectedCantons.length === 0)
            return true;

        //check if the canton of the current station is in the list of selected cantons
        return selectedCantons.includes(station.canton);
    };
}

export function createFilterByCapabilitiesFunction(selectedCapabilities, ignoreOrFilters, ignoreMigrolcardFilter) {
    return function (station) {

        //if selectedCapabilities is null or not defined, return true
        if (selectedCapabilities === null || selectedCapabilities === undefined)
            return true;

        var isStationOk = true;
        for (var group in selectedCapabilities) {
            if (!isStationOk)
                return false;

            var isGroupOk = true;

            if (selectedCapabilities[group].length > 0) {
                if (group.substr(0, 1) == 'a') {
                    isGroupOk = true;
                    for (let i = 0; i < selectedCapabilities[group].length && isGroupOk; i++) {
                        if (ignoreMigrolcardFilter && selectedCapabilities[group][i].filter === 0 /*migrolcard filter*/) {
                            //do not apply filter
                        } else {
                            isGroupOk = isGroupOk && station.capabilities.includes(selectedCapabilities[group][i].filter);
                        }
                    }
                } else {
                    isGroupOk = ignoreOrFilters ? true : false;
                    for (let i = 0; i < selectedCapabilities[group].length && !isGroupOk; i++) {
                        isGroupOk = isGroupOk || station.capabilities.includes(selectedCapabilities[group][i].filter);
                    }
                }
            }

            isStationOk = isStationOk && isGroupOk;
        }

        return isStationOk;
    }
}

export function isCapabilityFilterActive(filterStateArray, filter) {
    //check if there is a filter property with this group-name defined
    if (filterStateArray[filter.group] === undefined) {
        return false; //if undefined, the filter is not set
    }

    //the group exists, so we check if the filter is in inside the group
    var index = R.findIndex(R.propEq('filter', filter.filter))(filterStateArray[filter.group]);
    return index !== -1;
}